import { useQuery } from "@apollo/react-hooks";
import { MY_TIME_GET_EXAMINERS } from "my-time/graphql/queries";

export const useMyTimeExaminers = ({
  contractCode,
  locale,
}: {
  contractCode: string;
  locale: string;
}) => {
  const { data, loading, error } = useQuery(MY_TIME_GET_EXAMINERS, {
    fetchPolicy: "cache-and-network",
    variables: {
      contractCode,
      locale,
    },
  });

  return {
    data: data?.getMyTimeExaminers || [],
    loading,
    error,
  };
};

export default useMyTimeExaminers;
